export const searchFormOption = function () {
    return [
		{
		  prop: "orgId",
		  label: "所属机构",
		  type: "cascader",
		  placeholder: "请选择所属机构",
		  propConfig: {
		    children: "children",
		    label: "orgName",
		    value: "id",
		    checkStrictly: true,
		    emitPath: false,
		  },
		  options: this.orgOption,
		},
        {
            prop: 'keyword',
            label: '关键字',
            type: 'input',
            placeholder: '车牌号/流水号'
        },
        {
            prop: 'payStatus',
            label: '状态',
            type: 'select',
            width: '20%',
            options: [{
                label: '待支付',
                value: 1
            },
			{
			    label: '支付完成',
			    value: 2
			}]
        },
        {
            prop: 'date',
            label: '生成时间',
            type: 'range-date',
        },
    ]
}

export default {}